/*
 * @Author: 阿宇 969718197@qq.com
 * @Date: 2024-11-19 18:27:21
 * @LastEditors: 阿宇 969718197@qq.com
 * @LastEditTime: 2025-03-20 15:00:05
 * @Description:
 */
// 中文语言包
import zhCN from "./lang/zh";
// 英文语言包
import en from "./lang/en";
// 马来语语言包
import malay from './lang/malay';

const locales = {
  CN: zhCN,
  EN: en,
  MY: malay,
};

export default locales;
